import SvgConnection from './src/SvgConnection.vue'

SvgConnection.install = function(Vue) {
    Vue.component(SvgConnection.name, SvgConnection)
}

export default SvgConnection